import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {REMIT_BASE_URL} from './config';
import {RemitApiResponse} from './kyc/user-verification.service';

export interface StaffTestPhoneNumber {
  phoneNumber: string;
  label?: string | null;
  fixedOtp: string;
  active: boolean;
  createdBy: string;
  createdAt: string;
}

export interface CreateStaffTestPhoneNumberRequest {
  phoneNumber: string;
  label?: string;
}

export interface UpdateStaffTestPhoneNumberStatusRequest {
  phoneNumber: string;
}

export interface QueryStaffTestPhoneNumbersRequest {
  phoneNumber?: string;
  pageNumber: number;
  pageSize: number;
}

export interface StaffTestPhoneNumberMutationResponse extends RemitApiResponse {
  body: StaffTestPhoneNumber;
}

export interface StaffTestPhoneNumbersResponse extends RemitApiResponse {
  body: StaffTestPhoneNumber[];
  totalData: number;
}

@Injectable({
  providedIn: 'root',
})
export class StaffTestPhoneNumberService {
  constructor(
    private http: HttpClient,
    @Inject(REMIT_BASE_URL) private remitApiUrl: string,
  ) {}

  createTestPhoneNumber(
      body: CreateStaffTestPhoneNumberRequest,
  ): Observable<RemitApiResponse> {
    return this.http.post<RemitApiResponse>(
        `${this.remitApiUrl}/staff/test-phone-number`,
        body,
    );
  }

  activateTestPhoneNumber(
      body: UpdateStaffTestPhoneNumberStatusRequest,
  ): Observable<StaffTestPhoneNumberMutationResponse> {
    return this.http.post<StaffTestPhoneNumberMutationResponse>(
        `${this.remitApiUrl}/staff/test-phone-number/activate`,
        body,
    );
  }

  deactivateTestPhoneNumber(
      body: UpdateStaffTestPhoneNumberStatusRequest,
  ): Observable<StaffTestPhoneNumberMutationResponse> {
    return this.http.post<StaffTestPhoneNumberMutationResponse>(
        `${this.remitApiUrl}/staff/test-phone-number/deactivate`,
        body,
    );
  }

  queryTestPhoneNumbers(
      body: QueryStaffTestPhoneNumbersRequest,
  ): Observable<StaffTestPhoneNumbersResponse> {
    return this.http.post<StaffTestPhoneNumbersResponse>(
        `${this.remitApiUrl}/staff/test-phone-numbers`,
        body,
    );
  }
}
